// The live backend, in one place so a host change is a one-line edit.
export const PRODUCTION_API_URL = 'https://api.mamanalgerienne.com';

// Hosts the backend used to live on. Image URLs saved back then still carry
// them and those hosts are dead, so rewrite them to whatever backend is
// configured now.
const LEGACY_BACKEND_HOST = /^https?:\/\/(?:[^/]*\.onrender\.com|maman-algerienne-backend\.vercel\.app|bejewelled-marigold-772efa\.netlify\.app)/i;

const getApiBaseUrl = () => {
  const configured = process.env.REACT_APP_API_URL;
  if (configured) return configured.replace(/\/+$/, '');
  // Only a local dev machine talks to a local server; anything else (Render,
  // the custom domain) uses the deployed backend.
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return `http://${host}:5000`;
  return PRODUCTION_API_URL;
};

export const API_BASE_URL = getApiBaseUrl();
export const API_URL = `${API_BASE_URL}/api`;

export const getImageUrl = (path) => {
  if (!path) return '';
  if (path.startsWith('blob:')) return path;
  if (LEGACY_BACKEND_HOST.test(path)) return path.replace(LEGACY_BACKEND_HOST, API_BASE_URL);
  if (path.startsWith('http')) return path;
  return `${API_BASE_URL}${path}`;
};
